import { useEffect, useState } from "react";
import { query, where, limit, getDocs } from "firebase/firestore";
import { auth, doc, collection, db, onSnapshot } from "../../js/firebase.js";
import { FaCheck } from "react-icons/fa";
import { Cookies } from "../../index.js";
import { Link, useLocation } from "react-router-dom";
import { AiOutlineUserAdd, AiFillHeart } from "react-icons/ai";
import axios from "axios";
import { Tooltip } from "react-tooltip";
function Bannerprofile({ chedo }) {
  const [username, setusername] = useState(null);
  const [iduser, setiduser] = useState(null);
  const [user, setUser] = useState(null);
  const [code_store, setcode_store] = useState(null);
  const [content, setcontent] = useState(null);
  const [urlmuahang, seturlmuahang] = useState(null);
  const getUserByUsername = async () => {
    var numberString = iduser;
    var numberiduser = parseInt(numberString, 10);
    const userRef = query(
      collection(db, "users"),
      where("iduser", "==", numberiduser),
      limit(1)
    );
    const unsubscribe = onSnapshot(userRef, (querySnapshot) => {
      if (!querySnapshot.empty) {
        const docSnapshot = querySnapshot.docs[0];
        setUser(docSnapshot.data());
        console.log(querySnapshot.docs[0].data());
      } else {
        console.log("No such document!");
      }
    });
  };
  const [isFollowing, setIsFollowing] = useState(false);
  function laydulieuads2(urlapi) {
    axios
      .get(urlapi)
      .then((response) => {
        setiduser(response.data.iduser);
        setusername(response.data.username);
        if (response.data.code_store) {
          setcontent(response.data.content);
          setcode_store(response.data.code_store);
          seturlmuahang(response.data.urlmuahang);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  function laydulieuads() {
    console.log(chedo);
    if (chedo == "demo") {
      const apikey = Cookies.get("apikey");
      const urlapi =
        "https://kotlin.tecom.pro/bannerprofile?chedo=demo&apikey=" +
        apikey;
      laydulieuads2(urlapi);
    } else if (chedo == 'qualityviews') {
      const apikey = Cookies.get("apikey");
      const urlapi =
        "https://kotlin.tecom.pro/bannerprofile?chedo=qualityviews&apikey=" +
        apikey;
      laydulieuads2(urlapi);
    }
    else {
      const apikey = Cookies.get("apikey");
      const urlapi =
        "https://kotlin.tecom.pro/bannerprofile?chedo=ok&apikey=" +
        apikey;
      laydulieuads2(urlapi);
    }
  }
  const handleFollowClick = () => {
    setIsFollowing(!isFollowing);
  };
  useEffect(() => {
    laydulieuads();
  }, []);
  useEffect(() => {
    if (iduser) {
      getUserByUsername();
    }
  }, [iduser]);
  return (
    <>
      {user && (
        <div className="mx-1 grid grid-cols-1 md:grid-cols-1 gap-6">
          <div className="flex lg:col-span-1 items-center justify-between bg-white/40 rounded px-1 py-2">
            <div className="flex gap-1 items-center">

              <div className="mt-0">
                <p className="text-center text-[9px] mb-0 mt-0">
                  🌟Tài trợ 🌸bởi đối tác tin cậy
                </p>
                {/* <h2 className='text-sm text-white uppercase mb-0'>{username}</h2> */}

                <p
                  className="mt-0 text-lg uppercase mb-0 break-all"
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content="Hust Media 💫có thể thả 🎀banner quảng cáo🎀 ở mục quảng cáo shop! "
                >
                  {content ? (
                    <>{content}</>
                  ) : (
                    <>{user.caption ? user.caption.toString() : ""}</>
                  )}
                </p>

                <Tooltip className="max-w-xs mx-auto mb-0 break-all" id="my-tooltip" />

              </div>
            </div>

            <div className="flex flex-col gap-1 mt-2 justify-around sm:justify-start">
              <a
                href={code_store ? urlmuahang : user.lienket}
                style={{ textDecoration: "none" }}
                target="_blank"
              >
                <div className="flex justify-center items-center px-2 py-2 gap-1 border border-white rounded-sm grow sm:grow-0 cursor-pointer">
                  <div className="text-black no-underline text-sm">
                    &#10004;Đến liên kết mua hàng
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
export default Bannerprofile;
